module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Tools/Shovel-f2cc77b1b968bbef636e3ff883b97ba7.svg";